import React, { useState } from "react";
import {
  CenteredGridWithHeading,
  IconTitleDescriptionActionCard,
  SectionContainerBase,
} from "@reusejs/react";
import SectionHeading from "../SectionHeading";

let sectionDetails = {
  title: "Stats that matter",
  description: "",
};

const items = [
  {
    title: "5000+",
    description: "Subscribers",
  },
  {
    title: "100 Cr+",
    description: "worth of transactions",
  },
  {
    title: "45 Years+",
    description: "of cumulative experience",
  },

  {
    title: "900+",
    description: "Investment options",
  },
];

export interface StatComponentProps {
  investors: number;
  yearOfExperience: number;
  transactionWorth: number;
  investmentOptions: number;
  backgroundClasses?: any;
  headingTextColor?: any;
  subHeadingTextColor?: any;
  mainHeadingTextColor?: any;
  mainSubHeadingTextColor?: any;
  pageWiseBgColor?: any;
  pageWiseHeadingColor?: any;
  pageWiseDescriptionColor?: any;
  home?: boolean;
}

export default function StatComponent(props: StatComponentProps) {
  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: `py-10 md:py-20 overflow-hidden ${
          props.pageWiseBgColor
            ? props.pageWiseBgColor
            : "bg-stat-pattern bg-no-repeat bg-bottom"
        }`,
        innerContainerStyles: "relative bg-transparent",
      }}
    >
      <div id="statComponent" className="max-w-7xl mx-auto">
        <CenteredGridWithHeading
          headingSection={
            <SectionHeading
              title={sectionDetails.title}
              description={sectionDetails.description}
              itemTitleDescriptionCardBaseClasses={{
                titleWrapper: `${
                  props.home ? "text-center" : "text-start md:text-center"
                }`,
                titleStyles: `${
                  props.home
                    ? "text-2xl font-bold sm:text-4xl"
                    : "text-xl font-semibold md:text-4xl md:font-extrabold"
                } ${
                  props.pageWiseHeadingColor
                    ? props.pageWiseHeadingColor
                    : "text-blue-900"
                }`,
                descriptionWrapper: "text-center",
                descriptionStyles: "mt-3 text-lg sm:mt-4 text-gray-500",
              }}
            />
          }
          sectionContentData={items}
          itemsRenderer={() => (
            <ItemRendererComponent
              items={items}
              pageWiseHeadingColor={props.pageWiseHeadingColor}
              pageWiseDescriptionColor={props.pageWiseDescriptionColor}
              home={props.home}
            />
          )}
          centeredGridBaseClasses={{
            backgroundColor: "bg-transparent",
            gridClasses: `${
              props.home ? "grid-cols-2" : "grid-cols-1"
            } gap-0.5 sm:space-y-0 grid md:grid-cols-4 sm:gap-x-8 sm:gap-y-10 lg:place-items-center`,
          }}
        />
      </div>
    </SectionContainerBase>
  );
}

const ItemRendererComponent = (props?: any) => {
  return (
    <>
      {props.items.map((item?: any, index?: number) => {
        return (
          <IconTitleDescriptionActionCard
            key={index}
            title={item.title}
            icon={item.icon}
            description={item.description}
            itemTitleDescriptionCardBaseClasses={{
              titleWrapper: `${
                props.home
                  ? "text-center lg:text-start"
                  : "text-start lg:text-center"
              }`,
              titleStyles: `order-1 ${
                props.home
                  ? "text-2xl font-bold"
                  : "text-xl font-semibold md:text-2xl md:font-bold"
              }  ${
                props.pageWiseHeadingColor
                  ? props.pageWiseHeadingColor
                  : "text-blue-900"
              }`,
              descriptionWrapper: `${
                props.home ? "text-center mb-10" : "text-start mb-7"
              }  lg:text-start lg:mb-[initial]`,
              descriptionStyles: `${
                props.home ? "text-sm" : "text-base font-normal"
              } order-2 mt-1  leading-6 text-gray-500`,
            }}
          />
        );
      })}
    </>
  );
};
